import { render } from "./BovineDataTable.vue?vue&type=template&id=0d2f9a79"
import script from "./BovineDataTable.vue?vue&type=script&lang=js"
export * from "./BovineDataTable.vue?vue&type=script&lang=js"

import exportComponent from "/home/elias/web-farm/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__